import React, { useState, useEffect } from 'react';
import GenericEvaluationCard from './GenericEvaluationCard';
import Description from '@mui/icons-material/ViewList';
import { Card } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from 'hooks/apollo';
import { GET_GENERIC_EVALUATION_ENTITIES } from '../queries';
import { EVALUATE } from '../mutations';
import { useToast } from 'hooks/toasts/useToast';

const GenericEvaluationContainer = () => {
  const [evaluationParameters, setEvaluationParameters] = useState(null);
  const [evaluationResult, setEvaluationResult] = useState(null);
  const [evaluatingExpression, setEvaluatingExpression] = useState(false);
  const [localEvaluationEntity, setLocalEvaluationEntity] = useState(null);
  const addToast = useToast();
  const [modalOpen, setOpenModal] = React.useState(false);

  const { t } = useTranslation();

  const { data: genericEvaluationEntities, loading: genericEvaluationEntitiesLoading } = useQuery(GET_GENERIC_EVALUATION_ENTITIES);

  const [evaluateGenericExpression] = useMutation(EVALUATE);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCopyToClipboard = () => {
    addToast(t('TextCopied'), 'success');
  };

  const onGenericEvaluationParameterChanged = (itemPropertyName, itemValue) => {
    if (itemPropertyName === 'genericEvaluationEntity') {
      const evalEntity = {
        genericEvaluationEntityId: itemValue.genericEvaluationEntityId,
        name: itemValue.name
      };
      const params = {
        ...evaluationParameters,
        genericEvaluationEntityId: itemValue.genericEvaluationEntityId
      };
      setLocalEvaluationEntity(evalEntity);
      setEvaluationParameters(params);
    } else {
      const params = {
        ...evaluationParameters,
        [itemPropertyName]: itemValue
      };
      setEvaluationParameters(params);
    }
  };

  const initializeEvaluationParameters = () => {
    const params = {
      genericEvaluationEntityId: null,
      identifier: '',
      expression: ''
    };
    const evalEntity = {
      genericEvaluationEntityId: 0,
      name: ''
    };
    setEvaluationParameters(params);
    setLocalEvaluationEntity(evalEntity);
  };

  useEffect(() => {
    initializeEvaluationParameters();
  }, []);

  const onEvaluateGenericExpression = async () => {
    setEvaluatingExpression(true);
    const evaluationResultLocal = await evaluateGenericExpression({
      variables: {
        input: {
          genericEntityId: evaluationParameters.genericEvaluationEntityId,
          identifier: evaluationParameters.identifier,
          expression: evaluationParameters.expression
        }
      }
    });
    setEvaluationResult(evaluationResultLocal.data.evaluateGenericExpression);
    setEvaluatingExpression(false);
    if (evaluationResultLocal.data.evaluateGenericExpression.error) {
      addToast(evaluationResultLocal.data.evaluateGenericExpression.error, 'error');
    }
  };

  return (
    <Card icon={Description} iconColor='primary' title={t('GenericEvaluation.GeneralData')}>
      {evaluationParameters && evaluationParameters && localEvaluationEntity && !genericEvaluationEntitiesLoading && (
        <GenericEvaluationCard
          evaluatingExpression={evaluatingExpression}
          evaluationParameters={evaluationParameters}
          genericEvaluationEntities={genericEvaluationEntities?.genericEvaluationEntities}
          modalOpen={modalOpen}
          handleCloseModal={handleCloseModal}
          handleOpenModal={handleOpenModal}
          handleCopyToClipboard={handleCopyToClipboard}
          evaluationResult={evaluationResult}
          localEvaluationEntity={localEvaluationEntity}
          onGenericEvaluationParameterChanged={onGenericEvaluationParameterChanged}
          onEvaluateGenericExpression={onEvaluateGenericExpression}
        />
      )}
    </Card>
  );
};

export default GenericEvaluationContainer;
